<template>
  <div class="routerview">
    <iframe class="iframe-slide" src="/slides_iframe_tc_00overview"></iframe>
  </div>
</template>


<script>
    export default {
        name: "slidestc_00overview_en"
    }
</script>


<style scoped src="@/assets/css/globalen.css">
</style>
